import React, { useState } from "react";
import styles from "./switchRecipient.scss";
import PropTypes from "prop-types";
import { getOnbehalf } from "../../utils/loginSession";
import SwitchrecipientPopup from "../switchrecipientPopup/switchrecipient";

const SwitchRecipient = ({ text, width, onClick, variants, userName, breakpoint, router }) => {
  const onbehalf = typeof window !== "undefined" ? getOnbehalf() : { name: "" };
  const handleClick = () => {
    setShowPopup(true);
    document.body.style.overflow = document.documentElement.style.overflow = 'hidden';
    onClick();
  };

  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      {onbehalf.name && (
        <div className={styles.switchRecipient} style={{ width: width }}>
          <span>{text}：</span>
          <span className={styles.accName}>{onbehalf && onbehalf?.name?.trim?.()}</span>
          <span className={styles.btnSwitch} onClick={handleClick}>
            <em>切換</em>
          </span>
        </div>
      )}
      <SwitchrecipientPopup
        showPopup={showPopup}
        callBackClose={() => setShowPopup(false)}
        pVariant={variants}
        breakpoint={breakpoint}
        router={router}
      />
    </>
  );
};

SwitchRecipient.defaultProps = {
  text: "帳戶名稱",
  variants: "",
  onClick: () => { },
};

SwitchRecipient.propTypes = {
  userName: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  width: PropTypes.number,
  variants: PropTypes.string,
};

export default SwitchRecipient;
